import React, { memo } from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { IconProps } from './types'

const DEFAULT_SIZE = '1em'

export const Icon: React.FC<IconProps> = ({
  className: outerClassName,
  name,
  color,
  width: rawWidth,
  height: rawHeight,
  size,
  onClick
}) => {
  const className = classNames(styles.icon, outerClassName)

  const width = size ?? rawWidth ?? DEFAULT_SIZE
  const height = size ?? rawHeight ?? DEFAULT_SIZE

  return (
    <i
      className={ className }
      color={ color }
      onClick={ onClick }
    >
      <svg
        width={ size ?? width ?? '1em' }
        height={ size ?? height ?? '1em' }
        fill='currentColor'
        aria-hidden='true'
      >
        <use xlinkHref={ `#icon-${name}` } />
      </svg>
    </i>
  )
}

export const MemoizedIcon = memo(Icon)
